import { FunctionComponent } from 'react';
import { Button } from "../ui/button";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "../../TranslationContext";

import dtf_photo from "../../assets/png/dtf_photo.png";
import check_rakete from "../../assets/svg/check_rakete.svg";

const SampleKit: FunctionComponent = () => {
	const translations = useTranslation();

	return (
		<div className="w-full relative bg-white overflow-hidden flex flex-col items-center justify-start py-20 px-20 box-border text-left text-base text-slate-900 font-text-base-font-normal md:py-16 lg:px-10 md:px-10 sm:px-6 sm:py-16">
			<div className="w-full flex flex-col items-center justify-start max-w-[1280px]">
				<div className="self-stretch flex flex-row-reverse items-start justify-start gap-24 xl:gap-12 sm:flex-col">
					<img className="w-[450px] lg:w-[300px] relative rounded-[19.9px] max-h-full object-cover md:hidden sm:block" alt="" src={dtf_photo} />
					<div className="flex-1 w-full relative flex flex-col items-start justify-start gap-6 text-left">
						<div className="self-stretch flex flex-col items-start justify-start gap-2">
							<div className="self-stretch relative tracking-[-0.01em] leading-[125%] font-extrabold text-nebula-900 text-4xl lg:text-3xl md:text-2xl">
								{translations.sampleKit.title}
							</div>
							<div className="self-stretch relative text-xl leading-[125%] text-slate-700">
								{translations.sampleKit.subtitle}
							</div>
						</div>
						<div className="self-stretch relative leading-[150%]">
							{translations.sampleKit.description}
						</div>
						<div className="self-stretch flex flex-col items-start justify-start gap-4">
							<div className="self-stretch relative leading-[150%]">
								{translations.sampleKit.whatsIncluded}
							</div>
							<div className="self-stretch flex flex-col items-start justify-start gap-2">
								<div className="self-stretch flex flex-row items-center justify-start gap-2">
									<img className="w-6 relative h-6 overflow-hidden shrink-0" alt="" src={check_rakete} />
									<div className="relative leading-[150%]">
										{translations.sampleKit.items.instructions}
									</div>
								</div>
								<div className="self-stretch flex flex-row items-center justify-start gap-2">
									<img className="w-6 relative h-6 overflow-hidden shrink-0" alt="" src={check_rakete} />
									<div className="relative leading-[150%]">
										{translations.sampleKit.items.samples}
									</div>
								</div>
								<div className="self-stretch flex flex-row items-center justify-start gap-2">
									<img className="w-6 relative h-6 overflow-hidden shrink-0" alt="" src={check_rakete} />
									<div className="relative leading-[150%]">
										{translations.sampleKit.items.fabric}
									</div>
								</div>
							</div>
						</div>
						<div className="flex flex-col items-start justify-center text-white">
							<RouterLink to="/order-sample-kit">
								<Button
									variant="default"
									size="lg"
									onClick={() => window.scrollTo(0, 0)}
								>
									{translations.sampleKit.orderButton}
								</Button>
							</RouterLink>
						</div>
					</div>
				</div>
			</div>
		</div>);
};

export default SampleKit;
